import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getComments = (section = '', value = '') => {
  const url = `${API_URL}/api/v1/comment`;
  const params = {};
  if (section) params.section = section;
  if (value) params.value = value;

  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { params, validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetComments(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetComments(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetComments({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetComments = (data) => ({
  type: types.cmGetComments,
  payload: data,
});

export const createComment = (value, section) => {
  const url = `${API_URL}/api/v1/comment/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, { value, section }, { validateStatus: false })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateComment(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data;
          dispatch(setCreateComment(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setCreateComment({ status: 'danger', error: true, message }));
        });
  };
};

export const setCreateComment = (data) => ({
  type: types.cmCreateComment,
  payload: data,
});

export const updateComment = (commentId, value, section) => {
  const url = `${API_URL}/api/v1/comment/edit/${commentId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, { value, section }, { validateStatus: false })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateComment(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data;
          dispatch(setUpdateComment(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setUpdateComment({ status: 'danger', error: true, message }));
        });
  };
};

export const setUpdateComment = (data) => ({
  type: types.cmUpdateComment,
  payload: data,
});

export const deleteCommentById = (commentId) => {
  const url = `${API_URL}/api/v1/comment/${commentId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteCommentById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['commentId'] = commentId;
        dispatch(setDeleteCommentById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteCommentById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteCommentById = (data) => ({
  type: types.cmDeleteCommentById,
  payload: data,
});
